import type { FunctionalComponent as FC } from 'vue'

type IProps = {
  list: any[]
  checkList: (number | string)[]
  hasOlder?: boolean
  onCheckAllChange?: (v: boolean) => void
}

type IEvents = {
  checkAllChange(v: boolean): void
}

export const CheckAll: FC<IProps, IEvents> = (props, { emit }) => {
  const { $t } = useNuxtApp()
  const checkAll =
    !!props.list.length && props.checkList.length === props.list.length
  const indeterminate =
    !!props.checkList.length && props.checkList.length < props.list.length
  return (
    <>
      <a-checkbox
        checked={checkAll}
        indeterminate={indeterminate}
        onChange={(e: any) => emit('checkAllChange', e.target.checked)}
      >
        {$t('quan-xuan')}
      </a-checkbox>
      {props.hasOlder !== false && (
        <span>
          {$t('yi-xuan-statecheckedlistlength-ge', [props.checkList.length])}
        </span>
      )}
    </>
  )
}
